import {AfterViewInit, Component, HostListener, OnInit, ViewChild, ElementRef} from '@angular/core';
import {Location} from "@angular/common";
import {ActivatedRoute, Router} from "@angular/router";
import {NgForm} from "@angular/forms";
import {TelaExpandidaComponent} from "../TelaExpandida";
import {PedidoLoja} from "../objetos/PedidoLoja";
import {PedidoLocalService} from "../../services/pedido-local.service";
import {ConstantsService} from "../../fidelidade/ConstantsService";
import {PedidosService} from "../../services/pedidos.service";
import {AutorizacaoService} from "../../services/autorizacao.service";
import {ContatosService} from "../../services/contatos.service";
import {EnderecoService} from "../../services/endereco.service";
import {TelaAdicionarProdutoPdvComponent} from "../tela-adicionar-produto-pdv/tela-adicionar-produto-pdv.component";
import {GridPagamentoComponent} from "../grid-pagamento/grid-pagamento.component";
import {BuscarContatoComponent} from "../../componentes/buscar-contato/buscar-contato.component";
import {ListaDePedidosComponent} from "../lista-de-pedidos/lista-de-pedidos.component";
import {DTOEmpresa} from "../objetos/DTOEmpresa";
import {Entrega} from "../objetos/Entrega";
import {Endereco} from "../objetos/Endereco";
import {FormaDeEntrega} from "../objetos/FormaDeEntrega";
import {TipoDePagamentoEnum} from "../objetos/TipoDePagamentoEnum";

@Component({
  selector: 'app-tela-novo-pedido-pdv',
  templateUrl: './tela-novo-pedido-pdv.component.html',
  styleUrls: ['./tela-novo-pedido-pdv.component.scss']
})
export class TelaNovoPedidoPdvComponent extends TelaExpandidaComponent implements OnInit, AfterViewInit {
  @ViewChild('frm') frm: NgForm;
  @ViewChild('telaAdicionarProduto') telaAdicionarProduto: TelaAdicionarProdutoPdvComponent;
  @ViewChild('gridPagamentos') gridPagamentos: GridPagamentoComponent;
  @ViewChild('buscarContato') buscarContato: BuscarContatoComponent;
  @ViewChild('listaDePedidos') listaDePedidos: ListaDePedidosComponent;

  // Estado do Pedido
  public pedido: PedidoLoja = new PedidoLoja();
  public empresa: any;
  public bloqueado: any;
  public carregando = false;

  // Controle de Interface
  public modoEdicao = false;
  public tituloPagina = 'Novo Pedido PDV';
  public abaAtual = 'carrinho'; // carrinho | pagamento

  // Dados de Cliente e Endereço
  public contato: any = {};
  public enderecos: any[] = [];
  public formasDeEntrega: any[] = [];
  public mapFormasDeEntrega: any = {};
  public calculandoTaxa = false;

  // Dados de Pagamento
  public formasDePagamento: any[] = [];
  public msgErro: string;
  public msgErroAdicionar: string;
  public aplicandoCupom = false;
  public erroCupom: string;
  public usarSaldo = false;
  public maximoCashback: number;
  @ViewChild('saldoUsarText', { static: false})  saldoUsarText: any;

  constructor(
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private _location: Location,
    private pedidoLocalService: PedidoLocalService,
    private constantsService: ConstantsService,
    private pedidosService: PedidosService,
    private autorizacaoService: AutorizacaoService,
    private contatosService: ContatosService,
    private enderecoService: EnderecoService
  ) {
    super();
  }

  ngOnInit() {
    this.carregando = true;

    // 1. Carregar Empresa e Configurações
    this.constantsService.empresa$.subscribe((empresa) => {
      if (!empresa) return;
      this.empresa = empresa;
      this.pedido.dtoEmpresa = new DTOEmpresa(empresa);

      // Configurar Formas de Entrega
      if (this.empresa.formasDeEntrega) {
        this.formasDeEntrega = [];
        this.empresa.formasDeEntrega.forEach((f: any) => {
          this.formasDeEntrega.push(Object.assign({}, f));
          this.mapFormasDeEntrega[f.nome] = f;

          if (f.permiteComerNoLocal) {
            let local = Object.assign({}, f);
            local.comerNoLocal = true;
            local.nome = 'Comer no local';
            this.formasDeEntrega.push(local);
          }
        });
      }

      // Configurar Formas de Pagamento
      if (this.empresa.formasDePagamento) {
        this.formasDePagamento = this.empresa.formasDePagamento.filter(f => !f.online && f.nome !== 'cashback');

        // Configura forma de pagamento cashback no pedido se existir
        const formaCashback = this.empresa.formasDePagamento.find(f => f.nome === 'cashback');
        if (formaCashback && this.pedido.cashback) {
           this.pedido.cashback.formaDePagamento = formaCashback;
        }
      }

      this.pedido.integracao = this.empresa.integracaoPedidoFidelidade;

      // Inicializar Tela de Produtos
      setTimeout(() => {
        if (this.telaAdicionarProduto) {
           this.telaAdicionarProduto.novoItem();
           if(this.pedido.dtoEmpresa && this.pedido.dtoEmpresa.ecommerce)
             this.telaAdicionarProduto.buscarNoServer = true;
        }
      }, 100);
    });

    // 2. Verificar Login
    this.autorizacaoService.estaLogado().then((resposta: any) => {
      this.bloqueado = resposta.bloqueado;
      if (!resposta.logado) this.router.navigateByUrl('/admin/login');
    });

    // 3. Carregar Pedido (Novo ou Edição)
    this.activatedRoute.queryParams.subscribe(async (queryParams: any) => {
      const codigoPedido = this.activatedRoute.snapshot.params.codigo;

      if (codigoPedido) {
        // Modo Edição (Carregar do Server)
        await this.carregarPedidoServer(codigoPedido);
      } else {
        // Modo Novo (Carregar do LocalStorage ou Iniciar Limpo)
        this.iniciarNovoPedido();
      }
      this.carregando = false;
    });
  }

  ngAfterViewInit() {
    if (this.pedido && this.listaDePedidos) {
      this.listaDePedidos.exibaPedido(this.pedido);
    }

    // Inicializar Tela de Produtos se necessário
    if (this.telaAdicionarProduto) {
       this.telaAdicionarProduto.novoItem();
       if(this.pedido.dtoEmpresa && this.pedido.dtoEmpresa.ecommerce)
         this.telaAdicionarProduto.buscarNoServer = true;
    }
  }

  salvePedido() {
    this.salvarEstado();
  }

  // --- Lógica de Pedido ---

  iniciarNovoPedido() {
    // Tenta recuperar do storage
    let pedidoSalvo = this.pedidoLocalService.obtenhaPedido('pdv_temp');
    if (pedidoSalvo && !pedidoSalvo.id) {
      this.pedido = pedidoSalvo;
    } else {
      this.pedido = new PedidoLoja();
      this.pedido.balcao = true; // Padrão PDV
      this.pedido.pago = true;
      this.pedido.identificacaoBalcao = 'Consumidor Final';
      this.pedido.entrega = new Entrega();

      // Define forma de entrega padrão (Retirar/Balcão)
      if (this.formasDeEntrega.length > 0) {
        const padrao = this.formasDeEntrega.find(f => f.tipo === 'RETIRAR') || this.formasDeEntrega[0];
        this.pedido.entrega.formaDeEntrega = padrao.descricao;
      }
    }

    if (this.listaDePedidos) this.listaDePedidos.exibaPedido(this.pedido);
  }

  async carregarPedidoServer(codigo: string) {
    try {
      const pedidoServer = await this.pedidosService.obtenhaPorCodigo(codigo);
      this.pedido = this.pedidoLocalService.obtenhaPedidoLojaPeloPedidoServer(pedidoServer, false);
      this.modoEdicao = true;
      this.tituloPagina = `Editar Pedido #${pedidoServer.codigo}`;

      if (this.pedido.contato) {
        this.contato = this.pedido.contato;
        this.buscarEnderecosCliente();
      }

      this.listaDePedidos.exibaPedido(this.pedido);
    } catch (e) {
      alert('Erro ao carregar pedido');
    }
  }

  salvarEstado() {
    this.pedidoLocalService.salvePedido(this.pedido, 'pdv_temp');
  }

  // --- Lógica de Cliente e Endereço ---

  contatoFoiBuscado(evento: any) {
    if (evento.contato && evento.contato.id) {
      this.contato = evento.contato;
      this.pedido.contato = this.contato;
      this.pedido.balcao = false; // Se buscou contato, assume que pode ser entrega

      // Configura fidelidade/cashback
      if (this.contato.cartoes && this.contato.cartoes.length) {
        if (this.pedido.integracao) {
          this.pedido.integracao.cartao = this.contato.cartoes.find(cartao =>
            cartao.plano.id === this.empresa.integracaoPedidoFidelidade.plano.id
          );
        }
        this.pedido.setTrocas();

        // Garante que a forma de pagamento do cashback esteja configurada
        if (this.pedido.cashback && !this.pedido.cashback.formaDePagamento && this.empresa.formasDePagamento) {
           this.pedido.cashback.formaDePagamento = this.empresa.formasDePagamento.find(f => f.nome === 'cashback');
        }
      }

      this.buscarEnderecosCliente();
      this.salvarEstado();
    }
  }

  buscarEnderecosCliente() {
    if (!this.contato.id) return;

    this.enderecoService.obtenhaEnderecos(this.contato).then((ends: any[]) => {
      this.enderecos = ends.map(e => {
        let end = Endereco.fromJson(e);
        end.descricaoCompleta = end.obtenhaEnderecoCompleto();
        return end;
      });

      // Seleciona o primeiro endereço se não houver um selecionado
      if (!this.pedido.entrega.endereco && this.enderecos.length > 0) {
        this.selecionarEndereco(this.enderecos[0]);
      }
    });
  }

  selecionarEndereco(endereco: Endereco) {
    this.pedido.entrega.endereco = endereco;
    this.calculeTaxaDeEntrega();
  }

  mudarTipoEntrega(tipo: 'BALCAO' | 'ENTREGA') {
    this.pedido.balcao = (tipo === 'BALCAO');

    if (this.pedido.balcao) {
      this.pedido.pago = true;
      this.pedido.entrega.taxaDeEntrega = null;
      this.pedido.entrega.formaDeEntrega = FormaDeEntrega.RETIRAR;
    } else {
      this.pedido.pago = false;
      this.pedido.entrega.formaDeEntrega = FormaDeEntrega.RECEBER_EM_CASA;
      if (this.pedido.entrega.endereco) {
        this.calculeTaxaDeEntrega();
      }
    }
    this.pedido.calculeTotal();
  }

  calculeTaxaDeEntrega() {
    if (this.pedido.balcao || !this.pedido.entrega.endereco) return;

    this.calculandoTaxa = true;
    this.enderecoService.calculeTaxaDeEntrega('Receber em casa', this.pedido.entrega.endereco, this.pedido.obtenhaSubTotal())
      .toPromise()
      .then((res: any) => {
        this.calculandoTaxa = false;
        if (res.sucesso) {
          this.pedido.entrega.setTaxaEntrega(this.pedido.entrega.endereco, res.data);
          this.pedido.calculeTotal();
        }
      })
      .catch(() => this.calculandoTaxa = false);
  }

  novoEndereco() {
    this.router.navigate(['/admin/pedidos/novo/endereco/novo'], {
      queryParams: {
        telefone: this.pedido.contato.codigoPais + this.pedido.contato.telefone,
        urlRetorno: this.router.url
      }
    });
  }

  editarEndereco() {
    if (!this.pedido.entrega.endereco) return;

    // Salva o endereço atual no serviço para edição
    this.pedidoLocalService.salvePedido(this.pedido, 'pdv_temp');

    this.router.navigate(['/admin/pedidos/endereco/editar'], {
      queryParams: {
        telefone: 'pdv_temp', // Usa o contexto temporário
        urlRetorno: this.router.url
      }
    });
  }

  // --- Lógica de Produtos ---

  adicioneProduto(itemPedido: any) {
    if (!this.listaDePedidos) {
      console.error('Lista de pedidos não inicializada');
      return;
    }

    if (!this.listaDePedidos.pedido) {
      this.listaDePedidos.exibaPedido(this.pedido);
    }

    this.listaDePedidos.adicione(itemPedido);
    this.salvarEstado();

    // Se mudou o subtotal, recalcula taxa
    if (!this.pedido.balcao) this.calculeTaxaDeEntrega();

    // Reseta a tela de adicionar para permitir inserção rápida
    this.telaAdicionarProduto.novoItem();
  }

  atualizeProduto(dados: any) {
    this.listaDePedidos.atualize(dados.indice, dados.item);
    this.salvarEstado();
    this.telaAdicionarProduto.novoItem(); // Sai do modo edição
  }

  editeItemPedido(dados: any) {
    this.telaAdicionarProduto.editeItem(dados.indice, dados.item);
  }

  canceleAdicionar(event: any) {
    this.telaAdicionarProduto.novoItem();
  }

  // --- Lógica de Pagamento e Finalização ---

  obtenhaSaldoCartao() {
    return this.pedido.obtenhaSaldo()
  }

  toggleUsarCashback(usar: boolean) {
    this.usarSaldo = usar;
    this.maximoCashback = this.pedido.obtenhaSaldo();

    if (usar) {
      if (!this.pedido.cashback.valor) {
        this.pedido.cashback.valor = this.pedido.cashback.cartao.pontos;
      }

      // Limita o valor ao total do pedido
      if (this.pedido.cashback.valor > this.pedido.subTotal) {
        this.pedido.cashback.valor = this.pedido.subTotal;
      }

      // Limita o valor ao saldo disponível
      if (this.maximoCashback > this.pedido.subTotal) {
        this.maximoCashback = this.pedido.subTotal;
      }
    } else {
      this.pedido.cashback.valor = 0;
    }

    this.recalculeComCashback();
    this.gridPagamentos.novoValorPagar(this.pedido.obtenhaValorAhPagar());
  }

  recalculeComCashback() {
    this.pedido.calculeTotal();
  }

  apliqueCupom() {
    if(!this.pedido.codigoCupom || this.aplicandoCupom) return;

    delete  this.erroCupom;
    this.aplicandoCupom = true;
    this.pedidosService.calculeDescontoCupom(this.pedido.codigoCupom, this.pedido.obtenhaDadosEnvio()).then( (cupom: any) => {
      this.aplicandoCupom = false;
      if(cupom.erro){
        this.erroCupom = cupom.erro;
      }  else {
        this.pedido.apliqueCupom(cupom)
        this.pedidoLocalService.salvePedido(this.pedido, 'pdv_temp');
        this.gridPagamentos.novoValorPagar(this.pedido.obtenhaValorAhPagar());
      }
    }).catch( (erro) => {
      this.aplicandoCupom = false;
      this.erroCupom = 'Ops! nao foi possível verificar o cupom'
    })
  }

  calculeTroco() {
    setTimeout( () => {
      this.pedido.troco = this.gridPagamentos.troco;
    }, 0);
  }

  mudouFormaPagamento() {
    this.recalculeTotal();
    this.calculeTroco();
  }

  alterouOpcaoMultiplasFormas() {
    this.pedido.pagamentos = [];
    if(this.pedido.id && this.pedido.descontoFormaDePagamento)
      this.pedido.descontoFormaDePagamento = 0;

    this.recalculeTotal();
  }

  recalculeTotal() {
    if(!this.pedido.pagamentos || this.pedido.pagamentos.length === 0)
      this.pedido.pagamentos = this.gridPagamentos.pagamentos;

    if(this.pedido.cupom && this.pedido.cupom.brindeResgate){
      this.pedido.codigoCupom = this.pedido.cupom.codigo;
      this.apliqueCupom();
    } else {
      this.pedido.codigoCupom = null
      this.pedido.cupom = null
      this.pedido.calculeTotal()
      if(this.gridPagamentos) this.gridPagamentos.novoValorPagar(this.pedido.obtenhaValorAhPagar());
    }
  }

  irParaPagamento() {
    if (!this.pedido.itens.length) {
      alert('Adicione produtos ao pedido.');
      return;
    }
    this.abaAtual = 'pagamento';
    setTimeout(() => {
       if(this.gridPagamentos) {
         this.gridPagamentos.novoValorPagar(this.pedido.total);
         if(this.pedido.pagamentos && this.pedido.pagamentos.length) {
            this.gridPagamentos.setPagamentos(this.pedido.pagamentos);
         }
       }
    }, 100);
  }

  voltarParaCarrinho() {
    this.abaAtual = 'carrinho';
    setTimeout(() => {
      if (this.listaDePedidos) {
        this.listaDePedidos.exibaPedido(this.pedido);
      }
    }, 100);
  }

  finalizarPedido() {
    this.msgErro = null;

    // 1. Validar Pagamento
    if(this.pedido.total){
      this.msgErroAdicionar = this.gridPagamentos.obtenhaErroPagamento();

      if(this.msgErroAdicionar != null) {
        this.msgErro = this.msgErroAdicionar;
        return;
      }
      this.pedido.pagamentos = this.gridPagamentos.pagamentos;

      let totalPago = this.pedido.obtenhaTotalPagamentosSemTaxaDaForma();
      let diferenca = this.pedido.obtenhaTotalPedidoSemTaxaForma() - totalPago;

      if(diferenca > 0.1){
        this.msgErro = String(`O total do pedido (R$ ${this.pedido.total}) é maior que os valores dos pagamentos selecionados (R$ ${totalPago})`);
        return;
      }

      if(diferenca < -0.1 &&  !this.pedido.temTroco()){
        this.msgErro = String(`O total do pedido (R$ ${this.pedido.total}) é menor que os valores dos pagamentos selecionados (R$ ${totalPago})`);
        return;
      }
    }

    if(this.pedido.totalResgatado){
      if(!this.pedido.resgate.usar){
        this.msgErro = "Marque opção 'usar meus " + this.pedido.acumulo + "'";
        return;
      }

      if(this.pedido.resgate.saldoInsuficente){
        this.msgErro = 'Seu saldo é insuficiente para o resgate';
        return;
      }

      this.pedido.resgate.valor = this.pedido.totalResgatado;
    }

    // 2. Enviar
    this.pedido.troco = this.gridPagamentos.troco;
    if(this.pedido.temTaxaPagamento() || this.pedido.temDescontoPagamento())
        this.pedido.calculeTotal();

    this.pedidoLocalService.salvePedido(this.pedido, 'pdv_temp');

    // Redireciona para confirmar (reutilizando a tela existente de confirmação para garantir o fluxo)
    // Ou implementa o envio direto aqui se quiser ser 100% single page.
    // Para manter "igual ao hoje", vamos redirecionar para a tela de confirmação final
    // mas passando os dados já prontos.

    this.router.navigate(['/admin/pedidos/novo/confirmar'], {
      queryParams: {
        telefone: 'pdv_temp',
        pdv: true
      }
    });
  }

  voltar() {
    this._location.back();
  }
}
